var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('Con1'),_c('Con2'),_c('Con3'),_c('Con4'),_c('Con5'),_c('Con6'),_c('Con7'),_c('Con8'),_c('Con9'),_c('Con10')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }